import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { INCIDENT_V2_SUMMARY } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { getIncidentSummaryByIdQuery } from '../api';

type IncidentSummaryResponse = {
  incidentV2: { id: string; title: string } | null;
};

const useIncidentSummaryById = (incidentId?: string | null) => {
  const selectedEnvId = useSelectedEnv();

  return useGraphqlQuery<IncidentSummaryResponse>({
    queryKey: [INCIDENT_V2_SUMMARY, incidentId, selectedEnvId],
    query: getIncidentSummaryByIdQuery,
    variables: { id: incidentId },
    enabled: !!incidentId,
  });
};

export default useIncidentSummaryById;
